import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-neutral-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.24em] text-neutral-500 mb-6">Let’s Build Together</p>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Ready to intern,
              <br />
              <span className="italic text-neutral-400">innovate</span> & inspire?
            </h2>
            <p className="mt-8 text-neutral-400 max-w-lg leading-relaxed">
              Whether you’re a student stepping into your career or a company scaling with intelligent
              software — Scontinent Technologies is your long-term partner.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to="/apply" data-testid="footer-apply-cta" className="btn-pill btn-pill--primary" style={{ background: "#fff", color: "#0a0a0a", border: "1px solid #fff" }}>
                Apply for Internship
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
              </Link>
              <Link
                to="/contact"
                data-testid="footer-contact-cta"
                className="btn-pill"
                style={{ border: "1px solid #404040", color: "#fafafa" }}
              >
                Talk to us
              </Link>
              <Link
                to="/admin"
                data-testid="footer-admin-cta"
                className="btn-pill"
                style={{ border: "1px solid #404040", color: "#a3a3a3" }}
              >
                Admin
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-10">
            <div>
              <p className="text-xs uppercase tracking-[0.24em] text-neutral-500 mb-4">Explore</p>
              <ul className="space-y-3 text-sm">
                <li><Link to="/" className="hover:text-white text-neutral-300">Home</Link></li>
                <li><Link to="/about" className="hover:text-white text-neutral-300">About</Link></li>
                <li><Link to="/internships" className="hover:text-white text-neutral-300">Internships</Link></li>
                <li><Link to="/services" className="hover:text-white text-neutral-300">Services</Link></li>
                <li><Link to="/samai" className="hover:text-white text-neutral-300">SamAI</Link></li>
                <li><Link to="/contact" className="hover:text-white text-neutral-300">Contact</Link></li>
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.24em] text-neutral-500 mb-4">Reach us</p>
              <ul className="space-y-4 text-sm text-neutral-300">
                <li className="flex gap-3">
                  <MapPin className="w-4 h-4 shrink-0 mt-1 text-neutral-400" strokeWidth={1.5} />
                  <span>{CONTACT.address}</span>
                </li>
                <li className="flex gap-3">
                  <Phone className="w-4 h-4 shrink-0 mt-1 text-neutral-400" strokeWidth={1.5} />
                  <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-white">
                    {CONTACT.phone}
                  </a>
                </li>
                <li className="flex gap-3">
                  <Mail className="w-4 h-4 shrink-0 mt-1 text-neutral-400" strokeWidth={1.5} />
                  <a href={`mailto:${CONTACT.email}`} className="hover:text-white">
                    {CONTACT.email}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-neutral-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-neutral-500">
          <div className="flex items-center gap-3">
            <img
              src="/assets/scontinent-logo.png"
              alt="Scontinent"
              className="w-7 h-7 object-contain opacity-90"
            />
            <span>© {new Date().getFullYear()} Scontinent Technologies Private Limited. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-6">
            <span className="font-mono uppercase tracking-[0.24em]">Intern · Innovate · Inspire</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
